import { Badge } from "antd"
import React from "react"

import { documentStatusColor } from "./document-status-visuals.ts"
import { documentTypeIcon } from "./document-type-visuals.ts"

// One decoration renderer per concept, shared by every surface that shows
// Status/Document Type (the table cell and its picker, File Details, and
// their read-only fallbacks) — so a viewer without edit rights sees exactly
// the same color/icon as someone who can change it, and neither ever drifts
// from the other's rendering.
export const renderStatusDecoration = (statusValue: string) => (
  <Badge color={documentStatusColor(statusValue)} />
)

export const renderDocumentTypeDecoration = (typeValue: string, iconOverride?: string) => {
  const Icon = documentTypeIcon(typeValue, iconOverride)
  return <Icon className="text-secondary" style={{ fontSize: 13 }} />
}
